module.exports = __webpack_public_path__ + "static/img/dahang-s.a4fa50b.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/dahang-s.png
// module id = W8oG
// module chunks = 1